import React, { useState } from 'react';
import './CustomBeforeAfterSlider.css';

import delimiterImage from './../assets/slider/slider.png';

function CustomBeforeAfterSlider({ firstImage, secondImage }) {
  const [delimiterPosition, setDelimiterPosition] = useState(50);

  const calculatePosition = (clientX, slider) => {
    if (!slider) return delimiterPosition; // Prevent errors if slider is null
    const rect = slider.getBoundingClientRect();
    const position = ((clientX - rect.left) / rect.width) * 100;
    return Math.min(100, Math.max(0, position));
  };

  const handleMouseMove = (e) => {
    const slider = e.currentTarget;
    if (!slider) return; // Prevent errors if slider is null
    const position = calculatePosition(e.clientX, slider);
    setDelimiterPosition(position);
  };

  const handleTouchMove = (e) => {
    const slider = e.currentTarget;
    if (!slider) return; // Prevent errors if slider is null
    const touch = e.touches[0];
    const position = calculatePosition(touch.clientX, slider);
    setDelimiterPosition(position);
  };

  return (
    <div
      className="custom-slider-container"
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
    >
      <div
        className="custom-slider-before"
        style={{ width: `${delimiterPosition}%` }}
      >
        <img src={firstImage} alt="Before" />
      </div>
      <div className="custom-slider-after">
        <img src={secondImage} alt="After" />
      </div>
      <div
        className="custom-slider-delimiter"
        style={{ left: `${delimiterPosition}%` }}
      >
        <img src={delimiterImage} alt="Delimiter" />
      </div>
    </div>
  );
}

export default CustomBeforeAfterSlider;
